import React from "react";
import { Link } from "react-router-dom";

const AccessDenied = ({
  title = "Acces refuse",
  message = "Vous n'avez pas les permissions necessaires pour voir cette page.",
  showSignIn = false,
}) => (
  <section className="my-lg-14 my-8">
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-lg-7 col-md-9 col-12">
          <div className="card border-0 shadow-sm">
            <div className="card-body p-5 text-center">
              <div
                className="d-inline-flex align-items-center justify-content-center rounded-circle bg-light mb-4"
                style={{ width: 72, height: 72 }}
              >
                <i className="fas fa-lock text-dark fs-3" />
              </div>
              <h1 className="h3 mb-3">{title}</h1>
              <p className="text-muted mb-4">{message}</p>
              <div className="d-flex flex-wrap justify-content-center gap-2">
                {showSignIn ? (
                  <Link to="/MyAccountSignIn" className="btn btn-primary">
                    Se connecter
                  </Link>
                ) : null}
                <Link to="/Grocery-react/" className="btn btn-outline-secondary">
                  Retour au site
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default AccessDenied;
